import {Flex, useTheme} from '@chakra-ui/react';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import {TextA18} from '../../../components/typography';
import {Event} from '../../../types/article';

const Header = ({pass, event}: {pass?: any; event?: Event}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const backClicked = () => {
    if (event) {
      navigate(`/event/${event.id}/tickets`, {replace: true});
      return;
    }

    if (pass) {
      navigate(`/pass/${pass.id}/purchase`, {replace: true});
      return;
    }

    navigate(-1);
  };
  return (
    <Flex background={theme.colors.veryLightBlue} px={3} py={5} align="center" w="100%">
      <BackButton onClick={backClicked} />
      <TextA18 fontWeight="700" w="100%" textAlign="center" marginLeft="-18px">
        Checkout
      </TextA18>
    </Flex>
  );
};

export default Header;
